import { ArrowUpRight, Network } from "lucide-react";
import { useInView } from "../hooks/useInView";
import WaitlistForm from "./WaitlistForm";

export default function CTASection() {
  const [sectionRef, isInView] = useInView();

  return (
    <section
      id="cta"
      data-testid="cta-section"
      ref={sectionRef}
      className="pl-8 md:pl-16 pr-4 md:pr-8 py-16 md:py-32"
    >
      <div
        className={`bg-[#0D0D0D] rounded-3xl p-10 md:p-16 relative overflow-hidden transition-all duration-700 ${
          isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        {/* Background texture */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-[#cc4900] blur-[100px]" />
          <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-[#a33900] blur-[80px]" />
        </div>

        <div className="relative z-10 max-w-2xl">
          <div className="w-12 h-12 rounded-xl cta-gradient flex items-center justify-center mb-8">
            <Network size={22} className="text-white" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white leading-[1.1]">
            Stop losing deals to
            <br />
            forgotten follow-ups.
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/60 leading-relaxed max-w-md">
            Join 12,000+ founders who use Relio to turn their network into their most powerful fundraising asset.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="https://app.relio.in"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-join-button"
              className="cta-gradient text-white rounded-xl px-8 py-4 font-medium shadow-[0_8px_20px_rgba(204,73,0,0.4)] transition-transform hover:-translate-y-0.5 inline-flex items-center gap-2 text-base"
            >
              Join Now — It's Free
              <ArrowUpRight size={18} />
            </a>
            <a
              href="https://app.relio.in"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-demo-button"
              className="bg-white/10 hover:bg-white/15 text-white rounded-xl px-8 py-4 font-medium transition-colors inline-flex items-center gap-2 text-base"
            >
              Book a Demo
            </a>
          </div>

          {/* CTA Waitlist */}
          <div className="mt-8 max-w-md">
            <p className="text-xs text-white/40 mb-2 font-medium">Or get early access updates</p>
            <div className="[&_input]:bg-white/10 [&_input]:text-white [&_input]:placeholder:text-white/30 [&_input]:border-white/10 [&_input]:focus:ring-[#cc4900]">
              <WaitlistForm variant="inline" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div
        className={`mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 transition-all duration-700 delay-300 ${
          isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <div className="flex items-center gap-2.5">
          <div className="w-6 h-6 rounded-md cta-gradient flex items-center justify-center">
            <Network size={12} className="text-white" />
          </div>
          <span className="text-sm font-medium text-[#1c1b1d]">Relio</span>
        </div>
        <div className="flex flex-wrap gap-6">
          {["Privacy", "Terms", "Security", "Blog"].map((link) => (
            <a
              key={link}
              href="https://app.relio.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-[#5a4138] hover:text-[#a33900] transition-colors"
            >
              {link}
            </a>
          ))}
        </div>
        <p className="text-xs text-[#5a4138]">&copy; 2025 Relio. All rights reserved.</p>
      </div>
    </section>
  );
}
